import React from 'react'

export default function AddMovie() {
  return (
    <div>AddMovie</div>
  )
}
